import { render, staticRenderFns } from "./Spacing.vue?vue&type=template&id=1777d2a5"
import script from "./Spacing.vue?vue&type=script&lang=js"
export * from "./Spacing.vue?vue&type=script&lang=js"
import style0 from "./Spacing.vue?vue&type=style&index=0&id=1777d2a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports